module.exports = __webpack_public_path__ + "img/user-icon.dc3f8136.svg";